import { useState } from "react";
import { useBenefitLogin } from "@lib/context/shared/benefit-iframe-context";
import { permissionsManager } from "@lib/permissions/permissions-manager";
const isEntityLogin = permissionsManager.useEntityLogin();
const useAuthModals = () => {
  const {
    0: registerModalIsOpen,
    1: setRegisterModalIsOpen
  } = useState(false);
  const {
    0: loginModalIsOpen,
    1: setLoginModalIsOpen
  } = useState(false);
  const {
    openBenefitLogin
  } = useBenefitLogin();
  const loginFunction = () => {
    if (isEntityLogin) {
      openBenefitLogin();
    } else {
      setLoginModalIsOpen(true);
    }
  };
  const registerFunction = () => {
    if (isEntityLogin) {
      openBenefitLogin();
    } else {
      setRegisterModalIsOpen(true);
    }
  };
  return {
    loginModalIsOpen,
    setLoginModalIsOpen,
    registerModalIsOpen,
    setRegisterModalIsOpen,
    loginFunction,
    registerFunction
  };
};
export default useAuthModals;